<template>
  <b-container fluid class="main-login">
    <div class="background-image-wrapper" />
    <div class="background-wrapper" />
    <b-row class="h-100 justify-content-center align-items-center">
      <b-col
        class="align-self-center"
        cols="8"
        sm="8"
        md="6"
        lg="4"
        xl="4"
        align-self="center"
      >
        <b-card class="login-card">
          <div class="pt-3 pb-5">
            <img height="108" src="../assets/logo.png" alt="lab-vet-logo" />
          </div>
          <b-form class="px-5">
            <b-form-group>
              <b-form-input
                id="inputEmail"
                v-model="loginForm.username"
                type="text"
                class="login-input"
                placeholder="Username"
                required
                autofocus
                autocomplete="username"
                @keyup.enter="login()"
              />
            </b-form-group>
            <b-form-group>
              <b-form-input
                id="inputPassword"
                v-model="loginForm.password"
                type="password"
                class="login-input"
                placeholder="Password"
                required
                autocomplete="current-password"
                @keyup.enter="login()"
              />
            </b-form-group>
            <div class="pt-5">
              <b-button class="login-btn py-2" block @click="login()">
                Login
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      loginForm: {
        username: null,
        password: null,
      },
      response: null,
    };
  },
  created() {
    // this.setSpecies();
    // this.setGenders();
    // this.setContactTypes();
    // this.setSpecimenType();
    // this.setTestType();
    // this.setSetTest();
    // this.setDirection();
    // this.setCustomerType();
    // this.setCreditType();
    // this.setUrgencyHospitalType();
    // this.setStatus();
    // this.setCorporation();
  },
  methods: {
    ...mapActions({
      setCustomerData: "Hospital/getAll",
      setAnimalData: "Animal/setData",
      changeStatus: "History/changeStatus",
      setSpecies: "Species/setAll",
      setBreeds: "Breed/setAll",
      setGenders: "Gender/setAll",
      setContactTypes: "ContactType/setAll",
      setAdding: "History/setAdding",
      setSpecimenType: "Test/setSpecimenType",
      setTestType: "Test/setTestType",
      setSetTest: "Test/setSetTest",
      setDirection: "Direction/setAll",
      setCreditType: "CreditType/setAll",
      setCustomerType: "CustomerType/setAll",
      setUrgencyHospitalType: "UrgencyHospitalType/setAll",
      setStatus: "Status/setAll",
      setCorporation: "Corporation/setAll",
      setTestItem: "QualityControl/setTestItem",
      setQCName: "QualityControl/setQCName",
      setLotNo: "QualityControl/setLotNo",

      // setProvinces: "Address/setProvinces"
    }),
    async login() {
      this.$store.state.isLoading = true;
      let loginRes;
      try {
        loginRes = await this.$store.dispatch("Auth/login", this.loginForm);
      } catch (e) {
        await this.$swal.fire("Error", e.response.data.message);
        this.$store.state.isLoading = false;
        return;
      }

      try {
        await this.$store.dispatch("Auth/setUser", loginRes);
      } catch (e) {
        await this.$swal.fire("Error", e.response.data.message);
        this.$store.state.isLoading = false;
        return;
      }
      try {
        this.setSpecies();
        this.setBreeds();
        this.setGenders();
        this.setContactTypes();
        this.setSpecimenType();
        this.setTestType();
        this.setSetTest();
        this.setDirection();
        this.setCustomerType();
        this.setCreditType();
        this.setUrgencyHospitalType();
        this.setStatus();
        this.setTestItem();
        this.setQCName();
        this.setLotNo();
        this.setCorporation();
      } catch (e) {
        await this.$swal.fire("Error", e.message);
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;
      return this.$router.push({ name: "history" });
    },
  },
};
</script>
<style scoped>
.height-cutomize {
  height: 35vh !important;
}
.form-heading {
  color: #fff;
  font-size: 23px;
}
.panel h2 {
  color: #444444;
  font-size: 18px;
  margin: 0 0 8px 0;
}
.panel p {
  color: #777777;
  font-size: 14px;
  margin-bottom: 30px;
  line-height: 24px;
}
.login-form .form-control {
  background: #f7f7f7 none repeat scroll 0 0;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}
.main-div {
  background: #ffffff none repeat scroll 0 0;
  border-radius: 2px;
  margin: 10px auto 30px;
  width: 38%;
  padding: 50px 70px 70px 71px;
}

.login-form .form-group {
  margin-bottom: 10px;
}
.login-form {
  text-align: center;
}
.forgot a {
  color: #777777;
  font-size: 14px;
  text-decoration: underline;
}
.login-form .btn.btn-primary {
  background: #f0ad4e none repeat scroll 0 0;
  border-color: #f0ad4e;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
}
.forgot {
  text-align: left;
  margin-bottom: 30px;
}
.botto-text {
  color: #ffffff;
  font-size: 14px;
  margin: auto;
}
.login-form .btn.btn-primary.reset {
  background: #ff9900 none repeat scroll 0 0;
}
.back {
  text-align: left;
  margin-top: 10px;
}
.back a {
  color: #444444;
  font-size: 13px;
  text-decoration: none;
}
.main-login {
  height: 100vh;
}
.login-card {
  padding-bottom: 5rem;
  box-shadow: 2px 2px rgba(0, 0, 0, 0.2);
  background: white;
}
.background-image-wrapper {
  /* background-color: rgba(164, 24, 24, 1); */
  background-color: #00bfd9;
  height: 40vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.background-image-wrapper::after {
  content: "" !important;
  display: block !important;
  background-size: cover !important;
  background-position-y: 99% !important;
  opacity: 0.2 !important;
  /*z-index: 1 !important;*/
  background-image: url("../assets/login-background.png");
  height: 40vh;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.background-wrapper {
  position: absolute;
  width: 100%;
  height: 60vh;
  top: 40vh;
  left: 0;
  background: linear-gradient(180deg, #9c9c9c 0%, rgba(196, 196, 196, 0) 100%);
}
.login-btn {
  background: #00bfd9;
}
.login-input {
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0;
  font-size: 1.2rem;
}
.login-input::placeholder {
  color: black;
}
</style>
